import { useUserStore } from '@/stores/user';
import { Gauge, ScreenPreference, SubtitlePreference } from '@/types/components';

export const getScreenPreference = (): ScreenPreference => {
  const userStore = useUserStore();
  return {
    languageCode: userStore.pageLanguage,
    textSizeMultiplier: 1.0,
    screenMessageWidth: 95,
    screenScrollHeight: 50,
    screenContainerHeight: 500,
  };
};

export const getSubtitlePreference = (): SubtitlePreference => {
  const userStore = useUserStore();
  return {
    languageCode: userStore.pageLanguage,
    textSizeMultiplier: 1.0,
    subtitleOpacity: 0.8,
    subtitleLocationY: 1,
    subtitleLineHeight: 1.5,
    subtitleLineCount: 3,
    subtitleWidth: 99,
    subtitleBackgroundColor: 'GREEN',
    subtitleIsVisibleLogo: true,
    subtitleIsSettingAbove: true,
  };
};

export const SUBTITLE_PREFERENCE_GAUGE_PRESET: Record<
  string,
  Required<Omit<Gauge, 'modelValue' | 'disabled' | 'title'>>
> = {
  textSizeMultiplier: {
    min: 0.875,
    max: 2,
    increment: 0.125,
    minLabel: '0.875',
    maxLabel: '2',
  },
  subtitleLineHeight: {
    min: 1.3,
    max: 2,
    increment: 0.1,
    minLabel: '1.3',
    maxLabel: '2.0',
  },
  subtitleLineCount: {
    min: 2,
    max: 4,
    increment: 1,
    minLabel: 'subtitle_line_count_2',
    maxLabel: 'subtitle_line_count_4',
  },
  subtitleOpacity: {
    min: 0,
    max: 1,
    increment: 0.1,
    minLabel: '0',
    maxLabel: '1',
  },
  subtitleLocationY: {
    min: 0,
    max: 50,
    increment: 1,
    minLabel: '0%',
    maxLabel: '50%',
  },
};

export const SCREEN_PREFERENCE_GAUGE_PRESET: Record<
  string,
  Required<Omit<Gauge, 'modelValue' | 'disabled' | 'title'>>
> = {
  textSizeMultiplier: {
    min: 0.875,
    max: 2,
    increment: 0.125,
    minLabel: '0.875',
    maxLabel: '2',
  },
  screenScrollHeight: {
    min: 20,
    max: 60,
    increment: 10,
    minLabel: '20%',
    maxLabel: '60%',
  },
};
